// extracted by mini-css-extract-plugin
export default {"container":"Zq-z","heading":"_q-z","text":"ar-z","info":"br-z","link":"cr-z","fullMaxWidth":"dr-z"};